// extracted by mini-css-extract-plugin
export var base = "_2m-0";
export var updateBanner = "_2m-1";